import { render, staticRenderFns } from "./Aggregator.vue?vue&type=template&id=b60e3780"
import script from "./Aggregator.vue?vue&type=script&lang=js"
export * from "./Aggregator.vue?vue&type=script&lang=js"
import style0 from "./Aggregator.vue?vue&type=style&index=0&id=b60e3780&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports